// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-social path[data-v-ad171d94]{fill:currentColor !important}.content-social path[stroke-width][data-v-ad171d94]{stroke:currentColor !important}.content-social svg[data-v-ad171d94]{color:#000;width:18px;height:18px}", ""]);
// Exports
module.exports = exports;
